import { get } from 'lodash-es';
import { CollapseItem, CollapsableSidebarItem } from './types';

export const isCollapsableSidebarItem = (
  item: CollapseItem
): item is CollapsableSidebarItem => !!get(item, 'collapse');
